type Navigation = {
  push: (path: string, params?: any) => void;
};

export let navigation: Navigation = null as any;

export function setNavigation(_navigation: Navigation) {
  navigation = _navigation;
}
